import React, { useEffect, useReducer, useRef, useState } from 'react';
import { CharCounter, StyleGPTInput } from './GPTInput.styles';

const PLACEHOLDER_ROTATE_DURATION_MS = 4000;

export interface GPTInputProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  placeholders?: string[];
}

export const GPTInput = ({ placeholders: placeholderValues, placeholder, value, maxLength, ...restProps }: GPTInputProps) => {
  const [currentPlaceholderIndex, setCurrentPlaceholderIndex] = useState(0);

  useEffect(() => {
    setCurrentPlaceholderIndex(0);
  }, [placeholderValues]);

  useEffect(() => {
    let timeoutHandle: NodeJS.Timeout;

    if (placeholderValues) {
      timeoutHandle = setTimeout(() => {
        const nextIndex = (currentPlaceholderIndex + 1) % placeholderValues.length;
        setCurrentPlaceholderIndex(nextIndex);
      }, PLACEHOLDER_ROTATE_DURATION_MS);
    }

    return () => {
      clearTimeout(timeoutHandle);
    };
  }, [currentPlaceholderIndex, placeholderValues]);

  return (
    <>
      <StyleGPTInput placeholder={placeholderValues?.[currentPlaceholderIndex] || placeholder} {...restProps} />
      <CharCounter>
        {value?.toString().length || 0}/{maxLength || 1}
      </CharCounter>
    </>
  );
};
